import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import usePortalQuery from 'src/Libs/api/hooks/use-portal-query'
import { CACHE_TIME } from 'src/Libs/installations/constants'
import { fetchRetrofitPartnersList } from '../api'
import { RetrofitPartnerContact } from '../models'

interface RetrofitPartnersHook {
  data: RetrofitPartnerContact[]
  isLoading: boolean
  isError: boolean
}

/**
 * Hook to fetch list of retrofit partners for a given installation (aka installers of this installation).
 * @param installationId
 * @returns
 */
export const useRetrofitPartners = (installationId: string | undefined): RetrofitPartnersHook => {
  const authFetch = useAuthFetchWithResponse()

  const { data, isLoading, isError } = usePortalQuery({
    queryKey: ['retrofitPartnersList', installationId],
    queryFn: () => fetchRetrofitPartnersList(installationId, authFetch),
    enabled: !!installationId,
    staleTime: CACHE_TIME,
  })

  return { data: data ?? [], isLoading, isError }
}
